//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { assign } from '~/assets/js/utils.js'
export default {
  components: {
    'telegram-login': () => import('~/components/login/quickTelegramLogin.vue')
  },
  props: {
    loginRegiswitch: { // 登录注册切换状态
      type: String, default: ''
    },
    switchState: { // 显示状态
      type: String, default: ''
    }
  },
  data () {
    return {
      thirdIcons: [] // 第三方登录logo
    }
  },
  computed: {
    ...mapState(['screenWidth', 'locale', 'suffix']),
    // 用户IP是否在国外
    inAbroad () {
      return this.$store?.state?.myCountry != 'cn'
    },
    // 完整的域名
    fullDomain () {
      return this.$store?.state?.fullHost || ''
    },
    // 完整的页面链接
    completeUrl () {
      return this.fullDomain + this.$route?.fullPath
    }
  },
  created () {
    // this.thirdIcons = this.inAbroad ? [{ type: 1, icon: 'https://resources.interface003.com/web20/img/login/weixin.svg' }, { type: 2, icon: 'https://resources.interface003.com/web20/img/login/facdbook.svg' }, { type: 3, icon: 'https://resources.interface003.com/web20/img/login/Google.svg' }, { type: 4, icon: 'https://resources.interface003.com/web20/img/login/apple.svg' }, { type: 7, icon: 'https://resource.fx994.com/images/login/third-tele.svg' }] : [{ type: 1, icon: 'https://resources.interface003.com/web20/img/login/weixin.svg' }, { type: 2, icon: 'https://resources.interface003.com/web20/img/login/facdbook.svg' }, { type: 4, icon: 'https://resources.interface003.com/web20/img/login/apple.svg' }] // 第三方登录logo
    this.thirdIcons = this.inAbroad ? [{ type: 1, icon: 'https://resources.interface003.com/web20/img/login/weixin.svg' }, { type: 2, icon: 'https://resources.interface003.com/web20/img/login/facdbook.svg' }, { type: 7, icon: 'https://resource.fx994.com/images/login/third-tele.svg' }] : [{ type: 1, icon: 'https://resources.interface003.com/web20/img/login/weixin.svg' }, { type: 2, icon: 'https://resources.interface003.com/web20/img/login/facdbook.svg' }] // 第三方登录logo
  },
  mounted () {
    if (this.$store?.getters?.halfHost != '.wikifx.com') this.thirdIcons = this.thirdIcons.filter(item => item.type != 7)
    this.getTripartite()
  },
  beforeDestroy () {
    this.buttonElement?.removeEventListener('click', this.appleBtnFn)
  },
  methods: {
    // 切换为“注册”功能
    registerFn () {
      this.$emit('loginSwitch')
    },
    // 获取三方地址
    async getTripartite () {
      try {
        const { succeed = false, result = [] } = await this.$api.login.userThird()
        if (succeed) {
          const [linkOne, linkTwo, that] = [result[0]?.LoginUrl, result[1]?.LoginUrl, this] // eslint-disable-line
          if (['1', '2'].includes(String(this.switchState))) { // 微信登录方式、Facebook登录方式
            assign(this.thirdIcons[0], { url: linkOne })
            assign(this.thirdIcons[1], { url: linkTwo })
          }
          this.thirdIcons.splice(this.thirdIcons?.length)
        }
      } catch (err) {}
    },
    // 苹果授权登录按钮点击事件
    appleBtnFn () {
      AppleID?.auth?.signIn()?.then(async (data) => { // eslint-disable-line
        try {
          const res = await this.$api.login.invokeClient({ HttpMethod: 'get', Route: 'usercenter$webapplecallback' }, { code: data?.authorization?.code })
          this.googleLogin(res)
        } catch (err) {}
      })
    },
    // 谷歌初始化成功
    onSuccess (obj = {}) {
      this.onGoogleAuthSuccess(obj?.credential)
    },
    // 谷歌授权成功
    async onGoogleAuthSuccess (value = '') {
      try {
        const res = await this.$api.login.invokeClient({ HttpMethod: 'post', Route: '/usercenter/web/googlecallback' }, { Token: value })
        this.googleLogin(res || {})
      } catch (err) {}
    },
    // telegram授权成功后的回调函数
    async telegramCallbackFn (obj = {}) {
      try {
        const res = await this.$api.login.invokeClient({ HttpMethod: 'post', Route: 'usercenter$telegramcallback' }, { auth_date: obj.auth_date, id: obj.id, first_name: obj.first_name, last_name: obj.last_name, hash: obj.hash, photo_url: obj.photo_url || '' })
        this.googleLogin(res || {})
      } catch (err) {}
    },
    // 存储cookie值
    async googleLogin (obj = {}) {
      const { isRegister = false, cookieValue = '', id = '', nickName = '', img = '', loginType = 1, email = '' } = obj || {}
      if (isRegister) {
        try {
          const { userId = '', nick = '', avatar = '' } = await this.$api.login.getUserCookieClient({ contentcookie: cookieValue })
          this.$store.commit('setVal', { cookieVal: cookieValue, simpleUser: { userId, nick, avatar }, loginShow: false })
          if (this.fullDomain?.includes('wikifx')) this.setCookie('DJkdikKMG', cookieValue)
          else if (this.fullDomain?.includes('fxeye')) this.setCookie('ViLartidlakd', cookieValue)
          else {
            this.$cookies.set('WsdsfgDGdagYms', cookieValue)
            const postdata = { op_type: 'setCookie', url: '', parm: cookieValue }
            window?.parent?.postMessage(postdata, '*')
          }
          this.$nextTick(() => {
            location?.reload()
          })
        } catch (err) {}
      } else {
        const externalTimer = setTimeout(() => {
          clearTimeout(externalTimer)
          const containQuestion = location?.href?.indexOf('?')
          const partialLink = location?.href?.substr(0, containQuestion) || location?.href
          const ulr = `?type=register&id=${id}&name=${nickName}&img=${img}&logintype=${loginType}&email=${email || null}&returnurl=${partialLink}`
          location.href = `https://${this.fullDomain}/${this.currLangCode()}/login.html${ulr}`
        }, 500)
      }
    },
    // 存储cookie
    setCookie (key = '', val = '') {
      this.$cookies.set(key, val, this.$store.getters.cookConf)
    }
  }
}
